import React, { Component } from 'react';
import {
  getEndOfWeek,
  getFormatMoment,
  getStartOfWeek,
} from '@/util/helpers/time-helpers';
import {
  YEAR,
  MONTH,
  WEEK,
  DAY,
  QUARTER,
} from '../util/enums/EnumDateTimeAggregation';
import {
  getEndOfQuarter,
  getStartOfQuarter,
} from '../util/helpers/time-helpers-ts';
import { DATE_TIME_INPUT } from '../constants/test-ids';

const TWO_INPUT_FIELD_FILTERS = [WEEK, QUARTER];

/**
 * Implementation of https://github.com/webjars/bootstrap-datetimepicker
 */
class DateTimePicker extends Component {
  componentDidMount() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const me = this;

    const { aggregation } = this.props;

    const format = this.getFormat(aggregation);
    const startView = this.getStartView(aggregation);
    const minView = aggregation ? startView : 'day'; // strangely enough, 'day' means the user has to select the hour, but not the seconds

    // properties described here: https://github.com/smalot/bootstrap-datetimepicker
    $(this.datetimepicker)
      .datetimepicker({
        todayHighlight: true,
        autoclose: true,
        minView,
        initialDate: today,
        todayBtn: false,
        forceParse: false,
        format,
        startView,
      })
      .on('changeDate', function (e) {
        let value = $(this).val();

        if (aggregation === 'week') {
          value = getStartOfWeek(value);
          $(this).val(value);
          const dateRangeEnd = getEndOfWeek(value);
          const dateRangeEndInput = me.dateRangeEnd;
          $(dateRangeEndInput).val(dateRangeEnd);
        }

        if (aggregation === 'quarter') {
          value = getStartOfQuarter(value);
          $(this).val(value);
          const dateRangeEnd = getEndOfQuarter(value);
          const dateRangeEndInput = me.dateRangeEnd;
          $(dateRangeEndInput).val(dateRangeEnd);
        }

        // fire change event (so onChange works as expected)
        const { onChange } = me.props;
        if (onChange) {
          onChange(e);
        }
      });
  }

  getFormat(aggregation) {
    switch (aggregation) {
      case YEAR:
        return 'yyyy';
      case MONTH:
        return 'yyyy-mm';
      case WEEK:
        return 'yyyy-mm-dd';
      case DAY:
        return 'yyyy-mm-dd';
      case QUARTER:
        return 'yyyy-mm-dd';
      default:
        return 'yyyy-mm-dd hh:ii';
    }
  }

  getStartView(aggregation) {
    // more info: https://github.com/smalot/bootstrap-datetimepicker#startview

    switch (aggregation) {
      case YEAR:
        return 'decade';
      case QUARTER:
        return 'year';
      case MONTH:
        return 'year';
      case WEEK:
        return 'month';
      case DAY:
        return 'month';
      default:
        return 'month';
    }
  }

  render() {
    const { aggregation, value, onChange } = this.props;
    const placeholder = getFormatMoment(aggregation);

    const getEndValue = () => {
      if (!value) {
        return null;
      }
      switch (aggregation) {
        case QUARTER:
          return getEndOfQuarter(value);
        case WEEK:
          return getEndOfWeek(value);
      }
      return null;
    };

    return (
      <div>
        <input
          onChange={onChange}
          value={value ?? ''}
          type="text"
          className="form-control"
          ref={(input) => (this.datetimepicker = input)}
          placeholder={placeholder}
          data-testid={DATE_TIME_INPUT}
        />
        {TWO_INPUT_FIELD_FILTERS.includes(aggregation) && (
          <input
            type="text"
            value={getEndValue()}
            className="form-control margin-top-10"
            ref={(input) => (this.dateRangeEnd = input)}
            placeholder="No end date"
            readOnly
          />
        )}
      </div>
    );
  }
}

export default DateTimePicker;
